import { createI18n } from 'vue-i18n'
import type { SupportedLocale } from '@/stores/locale'
import ru from '@/locales/ru.yaml'
import en from '@/locales/en.yaml'
import vn from '@/locales/vn.yaml'

// Merge static pages translations
const ruMessages = { ...ru}
const enMessages = { ...en}
const vnMessages = { ...vn}

export type MessageSchema = typeof ruMessages

/**
 * Vue I18n instance
 * Composition API mode (legacy: false)
 * Поддерживаемые локали: ru, en, vn
 */
/**
 * Русская плюрализация (DEV-1758): «1 проект | 2 проекта | 11 проектов».
 * Встроенное правило vue-i18n английское, две формы — на русском оно даёт
 * «11 проекта». Сообщение перечисляет формы через `|` в порядке
 * один / несколько / много.
 */
export function russianPluralIndex(choice: number, choicesLength: number): number {
  if (choicesLength < 3) return choice === 1 ? 0 : choicesLength - 1

  const mod10 = choice % 10
  const mod100 = choice % 100

  if (mod10 === 1 && mod100 !== 11) return 0
  if (mod10 >= 2 && mod10 <= 4 && (mod100 < 12 || mod100 > 14)) return 1
  return 2
}

export const i18n = createI18n<[MessageSchema], SupportedLocale>({
  legacy: false,
  locale: 'ru',
  fallbackLocale: 'ru',
  messages: {
    ru: ruMessages,
    en: enMessages,
    vn: vnMessages,
  },
  pluralRules: {
    ru: russianPluralIndex,
  },
  globalInjection: true,
})

export default i18n
